import * as React from 'react';

function SvgInstagramMono(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.864 5.1c-1.062.048-1.788.217-2.422.463a4.891 4.891 0 00-1.767 1.151 4.89 4.89 0 00-1.151 1.767c-.247.635-.415 1.36-.464 2.422-.049 1.064-.06 1.404-.06 4.114s.011 3.05.06 4.113c.049 1.062.217 1.787.464 2.422a4.89 4.89 0 001.15 1.767 4.89 4.89 0 001.768 1.15c.635.248 1.36.416 2.422.465 1.064.048 1.404.06 4.113.06 2.71 0 3.05-.012 4.114-.06 1.062-.049 1.787-.217 2.422-.464a5.102 5.102 0 002.917-2.918c.247-.635.416-1.36.464-2.422.049-1.064.06-1.404.06-4.113 0-2.71-.011-3.05-.06-4.114-.048-1.062-.217-1.787-.463-2.422a4.892 4.892 0 00-1.151-1.767 4.89 4.89 0 00-1.768-1.15c-.634-.247-1.36-.416-2.421-.464-1.064-.049-1.404-.06-4.114-.06s-3.05.011-4.113.06zm8.145 1.795c.973.045 1.5.207 1.852.344.434.16.826.415 1.148.746.33.322.586.714.746 1.148.137.351.299.88.343 1.852.048 1.052.059 1.368.059 4.032 0 2.664-.01 2.98-.059 4.032-.044.972-.207 1.5-.343 1.852a3.304 3.304 0 01-1.894 1.893c-.351.137-.88.3-1.852.344-1.052.048-1.368.058-4.032.058-2.664 0-2.98-.01-4.032-.058-.972-.044-1.5-.207-1.852-.344a3.09 3.09 0 01-1.147-.746 3.09 3.09 0 01-.747-1.147c-.136-.352-.299-.88-.343-1.852-.048-1.053-.058-1.368-.058-4.032 0-2.664.01-2.98.058-4.032.044-.973.207-1.5.343-1.852.16-.434.415-.826.747-1.148a3.091 3.091 0 011.147-.746c.351-.137.88-.3 1.852-.344 1.053-.048 1.368-.058 4.032-.058 2.664 0 2.98.01 4.032.058zm-7.358 8.122a3.326 3.326 0 116.652 0 3.326 3.326 0 01-6.652 0zm-1.797 0a5.123 5.123 0 1010.247 0 5.123 5.123 0 00-10.247 0zm10.449-4.129a1.197 1.197 0 100-2.394 1.197 1.197 0 000 2.394z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgInstagramMono;
